'use strict';

var jsxRuntime = require('react/jsx-runtime');

const SocialFacebook = ({ testId, className })=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            jsxRuntime.jsx("g", {
                clipPath: "url(#clip0_2735_3784)",
                children: jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16 8.04891C16 3.60361 12.4183 0 8 0C3.58172 0 0 3.60361 0 8.04891C0 12.0663 2.92548 15.3962 6.75 16V10.3755H4.71875V8.04891H6.75V6.27563C6.75 4.25837 7.94436 3.1441 9.7717 3.1441C10.647 3.1441 11.5625 3.30131 11.5625 3.30131V5.28209H10.5537C9.55992 5.28209 9.25 5.90254 9.25 6.53906V8.04891H11.4688L11.1141 10.3755H9.25V16C13.0745 15.3962 16 12.0663 16 8.04891Z",
                    fill: "#1877F2"
                })
            }),
            jsxRuntime.jsx("defs", {
                children: jsxRuntime.jsx("clipPath", {
                    id: "clip0_2735_3784",
                    children: jsxRuntime.jsx("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

module.exports = SocialFacebook;
